import React from 'react'
import "./Residential.css"
import one from "./residence 1.jpg"
import two from "./residence 2.jpg"
import three from "./residence 3.jpg"
import four from "./residence 4.jpg"
import five from "./san 1.jpg"
import six from "./san 10.jpg"
import seven from "./san 11.jpg"
import eight from "./san 2.jpg"
import nine from  "./san 3.jpg"
import ten from "./san 4.jpg"
import eleven from "./san 5.jpg"
import twelve from "./san 6.jpg"
import thirt from "./san 9.jpg"




const Residential = () => {
  return (
    <div>
      <div className='hello'>
      <div className='paintin'>
      <img src={one} alt='knacker 104'/>
      <img src={thirt} alt='knacker 104'/>      
      <img src={eleven} alt='knacker 104'/>
      </div>
      <div className='paintin'>
      <img src={six} alt='knacker 104'/>
      <img src={three} alt='knacker 104'/>
      <img src={four} alt='knacker 104'/>
      </div>
        <div className='paintin'>
        <img src={nine} alt='knacker 104'/>
        <img src={seven} alt='knacker 104'/>
        <img src={twelve} alt='knacker 104'/>

        </div>
          <div className='paintin'>
          <img src={ten} alt='knacker 104'/>
          <img src={eight} alt='knacker 104'/>
          <img src={five} alt='knacker 104'/>
          </div>

          <div className='paintin'>
          <img src={two} alt='jwdb'/>
          </div>
      
    </div>
    </div>
  )
}

export default Residential
